import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTelecommunication = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4C11 4.55228 11.4477 5 12 5ZM12 5L14.5 14M12 5L9.5 14M16 1C16 1 17.5 2 17.5 4C17.5 6 16 7 16 7M8 1C8 1 6.5 2 6.5 4C6.5 6 8 7 8 7M7 23L8.11111 19M8.11111 19L9.5 14M8.11111 19H15.8889M17 23L15.8889 19M15.8889 19L14.5 14M14.5 14H9.5",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTelecommunication;
